import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { LinkTabNavHorizontal } from '../../components';

import css from './AccountSettingsTabs.module.css';

const PAGES = [
  {
    page: 'ContactDetailsPage',
    labelId: 'LayoutWrapperAccountSettingsSideNav.contactDetailsTabTitle',
  },
  { page: 'PasswordChangePage', labelId: 'LayoutWrapperAccountSettingsSideNav.passwordTabTitle' },
  { page: 'StripePayoutPage', labelId: 'LayoutWrapperAccountSettingsSideNav.paymentsTabTitle' },
  { page: 'HistoryPage', labelId: 'LayoutWrapperAccountSettingsSideNav.historyTabTitle' },
  {
    page: 'ManageAccountPage',
    labelId: 'LayoutWrapperAccountSettingsSideNav.manageAccountTabTitle',
  },
];

/**
 * Horizontal sub-navigation for account settings inside AccountShell.
 *
 * @component
 * @param {Object} props
 * @param {string} props.currentPage
 */
const AccountSettingsTabs = ({ currentPage }) => {
  const tabs = PAGES.map(({ page, labelId }) => ({
    text: <FormattedMessage id={labelId} />,
    selected: currentPage === page,
    linkProps: { name: page },
  }));
  return <LinkTabNavHorizontal className={css.root} tabRootClassName={css.tab} tabs={tabs} />;
};

export default AccountSettingsTabs;
